import { createFileRoute } from "@tanstack/react-router";
import AdminTagsPage from "@/admin/pages/tags";

export const Route = createFileRoute("/admin/tags")({
  component: AdminTagsPage,
});
